(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["qc-drop-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qc-drop-countdown')) {
    const requests = new Map();
    const clocks = new Set();
    let heartbeat;
    const stopHeartbeat = () => { clearInterval(heartbeat); heartbeat = undefined; };
    const syncHeartbeat = () => {
      if (!clocks.size || document.hidden) { stopHeartbeat(); return; }
      if (!heartbeat) heartbeat = setInterval(() => clocks.forEach(clock => clock.tick()), 1000);
    };
    const releaseClock = clock => { clocks.delete(clock); syncHeartbeat(); };
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) [...clocks].forEach(clock => clock.tick());
      syncHeartbeat();
    });
    const parisParts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    });
    const partsAt = timestamp => Object.fromEntries(
      parisParts.formatToParts(new Date(timestamp)).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)])
    );
    const parseParis = value => {
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value || '');
      if (!match) return NaN;
      const [, y, m, d, h, min] = match.map(Number);
      if (m < 1 || m > 12 || d < 1 || d > 31 || h > 23 || min > 59) return NaN;
      const target = Date.UTC(y, m - 1, d, h, min);
      let result = target;
      for (let i = 0; i < 4; i++) {
        const p = partsAt(result);
        const delta = target - Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
        if (!delta) break;
        result += delta;
      }
      const p = partsAt(result);
      return p.year === y && p.month === m && p.day === d && p.hour === h && p.minute === min ? result : NaN;
    };
    const sourceKey = value => {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) throw new Error('Invalid drop origin');
      url.search = '';
      url.hash = '';
      const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url.href;
    };
    const readConfig = node => ({
      start: node.dataset.start,
      end: node.dataset.end,
      enabled: node.dataset.dropEnabled !== 'false'
    });
    const findConfig = (root, key) => [...root.querySelectorAll('qc-drop-countdown[data-start][data-end][data-drop-source]')]
      .find(node => sourceKey(node.dataset.dropSource) === key);
    const getConfig = source => {
      const key = sourceKey(source);
      const local = findConfig(document, key);
      if (local) return Promise.resolve(readConfig(local));
      if (!requests.has(key)) {
        requests.set(key, (async () => {
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 10000);
          try {
            const response = await fetch(key, { credentials: 'same-origin', signal: controller.signal });
            if (!response.ok) throw new Error('Drop configuration unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const node = findConfig(html, key);
            if (!node) throw new Error('Drop section missing');
            return readConfig(node);
          } finally { clearTimeout(timeout); }
        })());
      }
      return requests.get(key);
    };
    customElements.define('qc-drop-countdown', class extends HTMLElement {
      connectedCallback() { this.refresh(); }
      disconnectedCallback() {
        this.generation = (this.generation || 0) + 1;
        releaseClock(this);
      }
      async refresh() {
        const generation = this.generation = (this.generation || 0) + 1;
        releaseClock(this);
        this.hidden = true;
        this.dropRoot = this.closest('[data-qc-drop-root]');
        this.label = this.querySelector('[data-drop-label]');
        this.output = this.querySelector('[data-drop-time]');
        if (!this.label || !this.output) return;
        try {
          const config = this.hasAttribute('data-start') ? readConfig(this) : await getConfig(this.dataset.dropSource);
          if (generation !== this.generation || !this.isConnected) return;
          if (!config.enabled) { this.updateRoot('off'); return; }
          this.start = parseParis(config.start);
          this.end = parseParis(config.end);
          if (!Number.isFinite(this.start) || !Number.isFinite(this.end) || this.end <= this.start) { this.updateRoot('off'); return; }
          const dates = this.querySelector('[data-drop-dates]');
          if (dates) {
            const format = new Intl.DateTimeFormat('fr-FR', {
              timeZone: 'Europe/Paris', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit'
            });
            dates.textContent = `Du ${format.format(this.start)} au ${format.format(this.end)} · heure de Paris`;
          }
          this.tick();
          if (Date.now() < this.end) { clocks.add(this); syncHeartbeat(); }
        } catch {
          if (generation === this.generation) { this.hidden = true; this.updateRoot('off'); }
        }
      }
      updateRoot(phase) {
        if (!this.dropRoot) return;
        if (this.dropRoot.dataset.qcDropPhase === 'upcoming' && phase === 'active') {
          this.dropRoot.dataset.qcDropNeedsRefresh = 'true';
        }
        if (phase === 'off') delete this.dropRoot.dataset.qcDropNeedsRefresh;
        if (this.dropRoot.dataset.qcDropPhase !== phase) this.dropRoot.dataset.qcDropPhase = phase;
      }
      tick() {
        const now = Date.now();
        if (now >= this.end) {
          this.updateRoot('ended');
          if (this.hasAttribute('data-keep-ended')) {
            this.label.textContent = 'Cette édition est terminée';
            this.output.textContent = 'À bientôt !';
            this.hidden = false;
          } else this.hidden = true;
          releaseClock(this);
          return;
        }
        const upcoming = now < this.start;
        this.updateRoot(upcoming ? 'upcoming' : 'active');
        const remaining = Math.ceil(((upcoming ? this.start : this.end) - now) / 1000);
        const hours = Math.floor(remaining / 3600);
        const minutes = Math.floor(remaining % 3600 / 60);
        const seconds = remaining % 60;
        const compact = this.dropRoot?.tagName === 'PRODUCT-CARD';
        const label = compact ? (upcoming ? 'Quest Drop · Ouverture' : 'Quest Drop · Fin') : (upcoming ? 'Quest Drop · Ouvre dans' : 'Quest Drop · Fin dans');
        if (this.label.textContent !== label) this.label.textContent = label;
        this.output.textContent = `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
        this.hidden = false;
      }
    });
    document.addEventListener('shopify:section:load', () => {
      requests.clear();
      document.querySelectorAll('qc-drop-countdown').forEach(node => node.refresh());
    });
  }
  } catch(e) { console.error(e); }
})();

})();
